export function Ico24Download({ ...props }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2550_13928)">
        <path
          d="M3.5 14.5703V16.0184C3.5 16.7865 3.74064 17.5232 4.16898 18.0663C4.59732 18.6094 5.17828 18.9146 5.78404 18.9146H17.2042C17.81 18.9146 18.391 18.6094 18.8193 18.0663C19.2476 17.5232 19.4883 16.7865 19.4883 16.0184V14.5703"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M11.5766 4.5V13.5994M11.5766 13.5994L8.25391 10.6647M11.5766 13.5994L14.7241 10.6647"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2550_13928">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
